<script setup lang="ts">
import { computedAsync } from "@vueuse/core"

const props = defineProps({
  file: null,
  peek: { type: Boolean }
})

const { getYoutubeVideoId } = useCache()
const src = computed(() => props.file.linkDestinationUrl())
const youtubeEmbed = computedAsync(async () => {
  const url = props.file.linkDestinationUrl()
  if (!url)
    return false
  const videoId = await getYoutubeVideoId(url)
  if (!videoId)
    return
  return `https://www.youtube.com/embed/${videoId}?autoplay=1`
})
const onLoad = () => {
  console.debug("Renderer loaded")
}
</script>

<template>
  <div
    class="renderer-container"
    tabindex="0"
    :class="{ peek }"
  >
    <iframe
      v-if="youtubeEmbed"
      tabindex="-1"
      class="renderer-iframe"
      :src="youtubeEmbed"
      width="853"
      height="480"
      frameBorder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
      allowFullScreen
      @load="onLoad"
    />
    <iframe
      v-else
      tabindex="-1"
      class="renderer-iframe"
      :src
      frameBorder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
      allowFullScreen
      @load="onLoad"
    />
  </div>
</template>

<style lang="sass" scoped>
@import '~/assets/styles/generated/variables.sass'

.renderer-container
  @apply flex items-center justify-center relative
  &.peek
    @apply w-[75vw] h-[75vh]

.renderer-iframe
  @apply absolute top-0 left-0 w-full h-full
</style>
